import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Composant éditable pour les nœuds d'action (Queue, User, Phone)
 * Affiche seulement un label avec le nom sélectionné (pas d'input de recherche)
 */
const EditableActionNode = ({ 
  nodeId, 
  type, 
  initialData, 
  onDataChange,
  ACTIVE_TENANT 
}) => {
  const [selectedData, setSelectedData] = useState(initialData || null);

  useEffect(() => {
    if (selectedData && onDataChange) {
      onDataChange(nodeId, selectedData);
    }
  }, [selectedData, nodeId, onDataChange]);

  // Rendu selon le type - affiche seulement le nom sélectionné
  if (type === 'queue') {
    return (
      <div className="node-queue">
        <div className="node-title">Queue</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-label">
            {selectedData?.displayName || 'No queue selected'}
          </div>
        </div>
      </div>
    );
  }

  if (type === 'user') {
    return (
      <div className="node-transfer-user">
        <div className="node-title"> Transfer User</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-label">
            {selectedData?.displayName || 'No user selected'}
          </div>
        </div>
      </div>
    );
  }

  if (type === 'phone') {
    return (
      <div className="node-transfer-pstn">
        <div className="node-title">☎️ Transfer Phone</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-label">
            {selectedData?.phoneNumber || 'No phone number'}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

const mapStateToProps = state => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
});

export default connect(mapStateToProps)(EditableActionNode);
